module.exports = __webpack_public_path__ + "36b58286fce0bd91cf15e21080c5876c.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Light.woff
// module id = 691
// module chunks = 0